jQuery(document).ready(function ($) {
  const $form = $("#filter-form");
  const $toggle = $("#filter-toggle");
  const $searchField = $('#product_name_search');
  const $productCat = $("#product_cat");
  const $filterCor = $("#filter_cor");
  const $orderby = $("#orderby");

  $("#product_cat, #filter_cor").each(function () {
    const placeholder = $(this).data("holder") || "";
    $(this).select2({
      placeholder: 'Selecione...',
      allowClear: true,
      width: "100%",
      closeOnSelect: false,
      language: {
        noResults: function () {
          return "Nenhum resultado encontrado";
        },
      },
    });
  });

  if ( $orderby.length ) {
    $orderby.select2({
      width: "100%",
      placeholder: "Ordenar por",
      minimumResultsForSearch: Infinity,
    });
  }

  function handleSearchField(e) {
    const searchValue = $.trim($searchField.val());

    if (searchValue) {
      e.preventDefault();
      const baseUrl = window.location.origin; // sempre envia para home
      const url = new URL(baseUrl);
      url.searchParams.set("s", searchValue);
      url.searchParams.set("post_type", "product");
      window.location.href = url.toString();
      return true;
    }

    return false;
  }

  // === Envio do formulário ===
  $form.on("submit", function (e) {
    // 1️⃣ Se for busca, ignora os demais campos
    if (handleSearchField(e)) return;

    e.preventDefault();

    const params = new URLSearchParams();

    const catValue = $productCat.val();
    const corValue = $filterCor.val();
    const orderbyValue = $orderby.val();

    if (catValue && catValue.length > 0)
      params.set("product_cat", catValue.join(","));
    if (orderbyValue) params.set("orderby", orderbyValue);
    if (corValue && corValue.length > 0)
      params.set("filter_cor", corValue.join(","));

    if (catValue && catValue.length > 0 && corValue && corValue.length > 0)
      params.set("query_type_cor", "or");

    const url = new URL(window.location.href);
    url.search = params.toString();
    window.location.href = url.toString();
  });

  // === Alternar exibição do formulário ===
  if ($toggle.length && $form.length) {
    $toggle.on("click", function () {
      $form.css("display", $form.css("display") === "flex" ? "none" : "flex");
    });
  }

  // === Pré-selecionar valores vindos da URL ===
  const currentParams = new URLSearchParams(window.location.search);
  currentParams.forEach((value, key) => {
    const $el = $(`[name="${key}"]`);
    if ($el.length) {
      const values = value.split(",");
      $el.val(values).trigger("change"); // atualiza Select2
    }
  });
});
